import { ReactComponent } from "./unchecked-box.svg";

interface Props {
  fill?: string;
  width?: number;
  height?: number;
}

const UncheckedBoxIcon: React.FC<Props> = ({ fill, width, height }) => (
  <ReactComponent
    fill={fill ? fill : "#BEC3CB"}
    width={width}
    height={height}
  />
);

export default UncheckedBoxIcon;
